import { useTribalContext } from '../context/tribal';

interface UsePdbConfig {
  pdbId?: string;
}

const usePdb = ({ pdbId }: UsePdbConfig) => {
  const { configManager } = useTribalContext();

  return {
    pdfUrl: `${configManager.get('apis.pdb')}/pdb/${pdbId}?format=pdf`,
  };
};

export default usePdb;
